import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["button"];
  static values = { multiple: Boolean };

  toggle(event) {
    const button = event.currentTarget;

    if (button.disabled) return;

    if (this.multipleValue) {
      this._toggleMultiple(button);
    } else {
      this._toggleSingle(button);
    }
  }

  _toggleSingle(button) {
    const wasSelected = button.dataset.selected === 'true';

    this.buttonTargets.forEach(btn => {
      btn.dataset.selected = 'false';
    });

    if (!wasSelected) {
      button.dataset.selected = 'true';
    }

    this._dispatchChangeEvent(button);
  }

  _toggleMultiple(button) {
    const wasSelected = button.dataset.selected === 'true';

    // Invert selection state
    button.dataset.selected = wasSelected ? 'false' : 'true';

    this._dispatchChangeEvent(button);
  }

  _dispatchChangeEvent(button) {
    const event = new CustomEvent('promote:segmented-buttons:change', {
      detail: {
        value: button.dataset.value,
        selected: button.dataset.selected === 'true',
        selectedValues: this._getSelectedValues()
      },
      bubbles: true
    });

    this.element.dispatchEvent(event);
  }

  _getSelectedValues() {
    return this.buttonTargets
      .filter(btn => btn.dataset.selected === 'true')
      .map(btn => btn.dataset.value);
  }

  getSelectedValues() {
    return this._getSelectedValues();
  }

  setSelected(value, selected = true) {
    const button = this.buttonTargets.find(btn => btn.dataset.value === value);

    if (button) {
      if (!this.multipleValue && selected) {
        this.buttonTargets.forEach(btn => {
          btn.dataset.selected = 'false';
        });
      }

      button.dataset.selected = selected ? 'true' : 'false';
    }
  }
}
